import { caseDetailPopup } from '@codametrix/shared-views';
import { openWindow } from '../../actions/ui';
import store from '../../store/store';
export const displayJsonInNewWindow = (data)=>{
    sessionStorage.setItem('json_view_data', JSON.stringify(data));
    store.dispatch(openWindow({
        ...caseDetailPopup,
        params: {
            hasInlineJson: true
        }
    }));
};
